﻿import {translation} from "@2d-front-monorepo/core";
import {MvvmValidation} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {useMemo} from "react";

const countries: Record<string, RegExp> = {
	"USA": /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
	"CAN": /^(\(\+[0-9]{2}\))?([0-9]{3}-?)?([0-9]{3})-?([0-9]{4})(\/[0-9]{4})?$/,
	"AUS": /^(\+?\(61\)|\(\+?61\)|\+?61|\(0[1-9]\)|0[1-9])?( ?-?[0-9]){7,9}$/,
	"ESP": /^(\d{9}|\d{3}[\s-]?\d{3}[\s-]?\d{3})$/
};

export default function usePhoneRequiredPolicy(countryId: string): MvvmValidation<string> {
	return useMemo<MvvmValidation<string>>(() => ({
		required: translation(PermitTranslations.validation__phone__required),
		validate: function (phone: string | undefined): string | undefined {
			//no pattern for this installation's country: only the required check applies
			const pattern = countries[countryId];
			if (pattern == null || pattern.test(phone ?? "")) {
				return undefined;
			}

			return translation(PermitTranslations.validation__phone__invalid);
		}
	}), []);
}
